import { render, staticRenderFns } from "./AddOnsPriceListTab.vue?vue&type=template&id=4c9be6ec"
import script from "./AddOnsPriceListTab.vue?vue&type=script&lang=ts"
export * from "./AddOnsPriceListTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports